export default __webpack_public_path__ + "static/media/home_thumb_UWO.7807a21d.png";